var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"msg"},[_vm._v("跳转中...")])
}
var staticRenderFns = []

export { render, staticRenderFns }